import { userRequest } from '@/utils/request';

// 用户中心 API 路径（不带 /user 前缀，因为 userRequest 已指向用户中心服务）
const Api = {
  UserCenterRegister: '/signup',
  UserCenterPostSendCodeUrl: '/signup/phone',
  UserCenterLoginUrl: '/auth/signin',
  passwordEditSandCodeUrl: '/account/password/phone',
  UserInfo: '/auth/user'
};

export function UserCenterPostSendCode (phone) {
  return userRequest.post({
    url: Api.UserCenterPostSendCodeUrl + '/' + phone + '/code'
  });
}

export function GetUserCenterRegister (data) {
  return userRequest.post({
    url: Api.UserCenterRegister,
    data
  });
}

export function UserCenterLogin (data) {
  return userRequest.post({
    url: Api.UserCenterLoginUrl,
    data
  });
}

export function passwordEditSandCode (phone) {
  return userRequest.post({
    url: Api.passwordEditSandCodeUrl + '/' + phone + '/code'
  });
}

export function passwordEdit (data) {
  return userRequest.post({
    url: Api.passwordEditSandCodeUrl,
    data
  });
}

export function GetUserInfo () {
  return userRequest.get({
    url: Api.UserInfo
  });
}


// WEBPACK FOOTER //
// ./src/api/userCenter.js